import * as ClassList from './classList';
import * as Events from './events';

export function addErrorClass(element, text, eventType) {
    if (ClassList.contains(element, "inputError")) {
        if (eventType === "change") {
            let errorDiv = element.parentNode.querySelector(".errorDiv");
            errorDiv.innerHTML = text;
            return;
        } else {
            return;
        }
    }

    ClassList.add(element, "inputError");

    Events.addEventOnce(element, eventType, e => {
        ClassList.remove(e.target, "inputError");

        // Find parent node, and then remove errorDiv.
        e.target.parentNode.removeChild(e.target.nextSibling);
    });

    addErrorDiv(element, text);

    element.focus();
}

// Helper to insert after instead of before
function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function addErrorDiv(element, text) {
    let errorDiv = document.createElement("div"),
        errorText = document.createTextNode(text);

    errorDiv.appendChild(errorText);
    ClassList.add(errorDiv, "errorDiv");

    insertAfter(element, errorDiv);
}